import { z } from 'zod'

export const slateTextSchema = z.object({
  text: z.string(),
})

export function isText(element?: unknown): element is SlateText {
  return element != null && typeof element === 'object' && 'text' in element && typeof (element as Record<string, unknown>).text === 'string'
}

export type SlateText = z.infer<typeof slateTextSchema>
